import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AccountFacade } from "@youm-front/account/data-access";
import { map } from "rxjs/operators";

@Injectable()
export class NotAuthorizedGuard {
  constructor(
    private readonly accountFacade: AccountFacade,
    private readonly router: Router
  ) {}

  canActivate() {
    return this.accountFacade.authorized$.pipe(
      map((_) => (_ ? this.router.createUrlTree(["/"]) : true))
    );
  }
}
